const UserRole = _ => {
    try {
        const userData = localStorage.getItem('user_data')
        return JSON.parse(userData).role_slug
    } catch (err) {
        return 'user';
    }
}

const userRoleName = _ => {
   return UserRole()
}

export { userRoleName }